export default "__VITE_ASSET__DeAGZfDh__"